import { defineStore } from 'pinia'
import axios from 'axios'
import router from '@/router/index.js' // 👈 Importăm router-ul aici

// Funcție utilitară care extrage o variabilă CSS (NU se modifică)
function getComputedCssVar(varName) {
    if (typeof window === 'undefined') return '#4c51bf'; // Fallback
    return getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim() || '#4c51bf';
}

export const useAppStore = defineStore('app', {
    state: () => ({
        // 🌗 Dark mode (Citim din localStorage la refresh. Dacă nu există, e false)
        darkMode: JSON.parse(localStorage.getItem('darkMode')) || false,

        // 🏫 Date despre școală
        school: null,
        schoolLoading: false,
        schoolError: null,
    }),

    actions: {
        // ✅ Toggle dark mode (Schimbăm valoarea și o salvăm instant în localStorage)
        toggleDark() {
            this.darkMode = !this.darkMode
            localStorage.setItem('darkMode', JSON.stringify(this.darkMode))
        },
        
        // ✅ Setează culorile custom în CSS (necesar pentru a popula variabilele)
        setCustomColors(primaryColor, accentColor) {
            if (typeof document !== 'undefined') {
                 document.documentElement.style.setProperty('--primary-color', primaryColor);
                 document.documentElement.style.setProperty('--accent-color', accentColor);
            }
        },

        // ✅ Setează detaliile școlii
        setSchoolDetails(data) {
             this.school = data;
             // Aplică culorile imediat ce primești datele
             this.setCustomColors(data.primary_color, data.accent_color);
        },

        // ✅ Încarcă detaliile școlii din API
        async fetchSchoolDetails() {
            this.schoolLoading = true
            this.schoolError = null

            try {
                const response = await axios.get('/school/details/')
                this.setSchoolDetails(response.data); // Folosește noua acțiune
            } catch (error) {
                console.error('❌ Eroare la încărcarea datelor școlii:', error)
                this.schoolError = 'Eroare la conectarea cu serverul.'
                
                // 🚀 Redirecționăm către pagina de eroare dacă pică serverul
                router.push({ name: 'ErrorPage' }); 
            } finally {
                this.schoolLoading = false
            }
        },
    },

    getters: {
        // getter opțional: pentru numele școlii, cu fallback
        schoolName: (state) =>
            state.school?.name || 'Școala Gimnazială „Mircea cel Bătrân”',

        // 🔴 NOU: GETTERS PENTRU CULORI ACCESIBILE DIN COMPONENTE SAU ALTE ACȚIUNI
        getComputedPrimaryColor: () => {
            // Nu folosește this.state, accesează funcția helper direct
            return getComputedCssVar('--primary-color');
        },
        getComputedAccentColor: () => {
            return getComputedCssVar('--accent-color');
        },
    },
})
// stores/useTeacherStore.js (sau similar)
import { ref, computed } from 'vue';

export const useTeacherStore = defineStore('teacher', () => {
    // --- Stări Brute (Raw State) ---
    const homeroomGroups = ref([]);
    const taughtSubjects = ref([]); // Lista de combinații (ex: Mate la 5A)
    const students = ref([]);
    const parents = ref([]);
    
    // --- ACȚIUNEA DE FETCH ---
    const fetchCoreData = async () => {
        try {
            const res = await axios.get("/teacher/data/core/");
            homeroomGroups.value = res.data.homeroom_groups || [];
            taughtSubjects.value = res.data.taught_subjects || [];
            students.value = res.data.students_in_groups || [];
            parents.value = res.data.parents_of_students || [];
        } catch (e) {
            console.error("Eroare la fetchCoreData", e);
        }
    };

    // --- GETTERS (AICI E SOLUȚIA) ---

    // 1. Creează o listă UNICĂ de clase predate
    const getUniqueTaughtGroups = computed(() => {
        const groups = new Map();
        for (const item of taughtSubjects.value) {
            // Presupunând că API-ul returnează un obiect 'student_group' anidat
            // Dacă nu, ajustează (ex: item.student_group_id, item.group_name)
            if (item.student_group && !groups.has(item.student_group.id)) {
                groups.set(item.student_group.id, item.student_group);
            }
        }
        return Array.from(groups.values());
    });
    
    // 2. Creează o listă UNICĂ de materii predate
    const getUniqueTaughtSubjects = computed(() => {
         const subjects = new Map();
         for (const item of taughtSubjects.value) {
            if (item.subject && !subjects.has(item.subject.id)) {
                subjects.set(item.subject.id, item.subject);
            }
         }
        return Array.from(subjects.values());
    });

    // 3. Formatează părinții pentru dropdown-uri
    const getFormattedParents = computed(() => {
        return parents.value.map(parent => ({
            id: parent.id,
            label: `${parent.last_name} ${parent.first_name}`, // Câmpul 'label' pe care îl caută dropdown-ul
        }));
    });

    return {
        fetchCoreData,
        homeroomGroups,
        students,
        // Componentele tale vor folosi ACESTEA:
        getUniqueTaughtGroups,
        getUniqueTaughtSubjects,
        getFormattedParents
    };
});